import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import KPICardWithTrend from "../KPICardWithTrend";
import CareManagerOverview from "./CareManagerOverview";
import styles from "./CareManagerSection.module.css";
import MonthYearPicker from "../../shared-modules/DatePicker/MonthYearPicker";
import { getCareManagerOverviewKpis } from "../../../services/super-admin-dashboard/careManagerOverview";


const CareManagerSection = ({ scope = "all", title = "Care Manager Overview" }) => {
  const [selectedMonthYear, setSelectedMonthYear] = useState("");

  const { data: kpis, isLoading } = useQuery({
    queryKey: ["care-manager-overview-kpis", scope, selectedMonthYear],
    queryFn: () => getCareManagerOverviewKpis(scope, selectedMonthYear || undefined),
    staleTime: 5 * 60 * 1000,
  });

  return (
    <div className={styles.sectionCard}>
      <div className={styles.headerRow}>
        <h2 className={styles.title}>{title}</h2>
        {/* <MonthYearPicker value={selectedMonthYear} onChange={setSelectedMonthYear} /> */}
      </div>
      <div className={styles.divider} />

      <div className={styles.kpiGrid}>
        <KPICardWithTrend
          title="Total Care Managers"
          value={isLoading ? "..." : String(kpis?.total_managers ?? 0)}
          className={styles.kpiBlue}
          isLoading={isLoading}
        />
        <KPICardWithTrend
          title="Total Calls"
          value={isLoading ? "..." : String(kpis?.total_calls ?? 0)}
          className={styles.kpiGreen}
          isLoading={isLoading}
        />
      
        <KPICardWithTrend
          title="Patients Assigned"
          value={isLoading ? "..." : String(kpis?.patients_managed ?? 0)}
          className={styles.kpiGray}
          isLoading={isLoading}
        />
      
      </div>

      <div className={styles.tableSection}>
        <CareManagerOverview scope={scope} selectedMonthYear={selectedMonthYear} />
      </div>
    </div>
  );
};

export default CareManagerSection;
